module.exports = __webpack_public_path__ + "static/media/bitBanner.954b9a12.png";